module.exports = __webpack_public_path__ + "img/et.fb976f97.png";